/* eslint-disable @typescript-eslint/no-explicit-any */
import { memo } from 'react';
import { useShallow } from 'zustand/shallow';
import { TNotificationModalRootTypes, useNotificationModalRootStore } from './notification-modal-root.store';
import UpdateCareNotificationModal from '../update-care-notification-modal/update-care-notification-modal';
import UpdateTicketingNotificationModal from '../update-ticketing-notification-modal/update-ticketing-notification-modal';

const modalMap: Partial<Record<TNotificationModalRootTypes, React.ComponentType<any>>> = {
  UpdateCareNotificationModal,
  UpdateTicketingNotificationModal,
};

// Memoize valid types to avoid recreating on every render
const validModalTypes = Object.keys(modalMap) as TNotificationModalRootTypes[];

const NotificationModalRoot = memo(() => {
  // Optimized: Only subscribe to modals that belong to this root
  // This prevents re-renders when other modal roots change
  const modals = useNotificationModalRootStore(
    useShallow((state) => state.modals.filter((modal) => validModalTypes.includes(modal.type)))
  );

  // RENDER
  return (
    <>
      {modals.map(({ type, props }, idx) => {
        const ModalComponent = modalMap[type];
        const key = `${type}-${idx + 1}`;

        if (!ModalComponent) return null;

        return <ModalComponent key={key} {...props} />;
      })}
    </>
  );
});
NotificationModalRoot.displayName = 'NotificationModalRoot';
export default NotificationModalRoot;
